import { EXTERNAL_API, MOCK_API } from '@/constants'

export const API_BASE = MOCK_API ? '/api' : '/agr-api'

export const API = {
  // auth
  LOGIN: EXTERNAL_API.AUTH.LOGIN,
  REGISTER: EXTERNAL_API.AUTH.REGISTER,
  LOGOUT: EXTERNAL_API.AUTH.LOGOUT,
  REFRESH_TOKEN: EXTERNAL_API.AUTH.REFRESH_TOKEN,
  FORGOT_PASSWORD: EXTERNAL_API.AUTH.FORGOT_PASSWORD,
  RESET_PASSWORD: EXTERNAL_API.AUTH.RESET_PASSWORD,
  EMAIL_VERIFY: EXTERNAL_API.AUTH.EMAIL_VERIFY,
  // cities
  CITIES: EXTERNAL_API.CITIES,
  // features
  FEATURES: EXTERNAL_API.FEATURES,
  // advertisements
  ADVERTISEMENTS: EXTERNAL_API.ADVERTISEMENTS.BASE,
  ADVERTISEMENTS_SEARCH: EXTERNAL_API.ADVERTISEMENTS.SEARCH,
  // properties
  PROPERTIES: EXTERNAL_API.PROPERTIES.BASE,
  // users
  USERS_FILTER: EXTERNAL_API.USERS.FILTER,
  USERS: EXTERNAL_API.USERS.BASE,
  // posts
  POSTS: EXTERNAL_API.POSTS.BASE,
  POSTS_SEARCH: EXTERNAL_API.POSTS.SEARCH,
  // countries
  COUNTRIES: EXTERNAL_API.COUNTRIES,
  // universities
  UNIVERSITIES: EXTERNAL_API.UNIVERSITIES,
  // courses
  COURSES: EXTERNAL_API.COURSES,
  // campuses
  CAMPUSES: EXTERNAL_API.CAMPUSES,
  // services included
  SERVICES_INCLUDED: EXTERNAL_API.SERVICES_INCLUDED,
  // bookings
  BOOKINGS: EXTERNAL_API.BOOKINGS,
  // exports
  EXPORTS: EXTERNAL_API.EXPORTS,
  // chat
  CHAT_CONVERSATIONS: EXTERNAL_API.CHAT.CONVERSATIONS,
  CHAT_MESSAGES: EXTERNAL_API.CHAT.MESSAGES,
  // stats
  STATS_TOKEN: EXTERNAL_API.STATS_TOKEN,
  // payments
  PRODUCTS: EXTERNAL_API.PAYMENTS.PRODUCTS,
  ORDERS: EXTERNAL_API.PAYMENTS.ORDERS
} as const

export const USER = {
  // profile
  PROFILE: EXTERNAL_API.PROFILE.BASE
} as const
